module.exports = "\n<div *ngFor=\"let highest of combinedObject?.environment?.highest\">\n\n\n</div>\n\n\n"